
import './ccf-attachment-preview-icon.module.scss';
import { SvgIcon } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfAttachmentPreviewIconProps {}

/**
 * Icon to be used to display preview icon over attachment
 * @param props -  CcfAttachmentPreviewIconProps
 * @example  <CcfAttachmentPreviewIcon />
 * @returns
 */
export function CcfAttachmentPreviewIcon(props: CcfAttachmentPreviewIconProps) {
  return (
    <SvgIcon
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      {...props}
    >
      <path
        d="M2.26079 2.49751H8.56079V0.69751H1.99079C0.820791 0.69751 0.460791 1.32751 0.460791 2.49751V13.2975C0.453442 13.5359 0.494976 13.7732 0.582834 13.9949C0.670692 14.2166 0.803013 14.418 0.971645 14.5867C1.14028 14.7553 1.34165 14.8876 1.56336 14.9755C1.78507 15.0633 2.02242 15.1049 2.26079 15.0975H6.76079V13.2975H2.26079V2.49751ZM10.3608 0.69751V5.19751H14.8608L10.3608 0.69751ZM13.6008 6.09751C12.9434 6.11051 12.2951 6.25407 11.6937 6.51984C11.0922 6.78561 10.5496 7.1683 10.0974 7.64564C9.64521 8.12298 9.29239 8.68546 9.05949 9.30037C8.8266 9.91528 8.71826 10.5704 8.74079 11.2275C8.75822 12.4078 9.17009 13.5484 9.91079 14.4675L7.03079 17.6175C6.96695 17.6738 6.91581 17.7431 6.88079 17.8206C6.84577 17.8982 6.82765 17.9824 6.82765 18.0675C6.82765 18.1526 6.84577 18.2368 6.88079 18.3144C6.91581 18.392 6.96695 18.4612 7.03079 18.5175C7.03079 18.6075 7.21079 18.6975 7.39079 18.6975C7.55768 18.6942 7.71764 18.6302 7.84079 18.5175L10.7208 15.3675C11.5243 15.9705 12.5064 16.2873 13.5108 16.2675C14.1682 16.2545 14.8165 16.1109 15.4179 15.8452C16.0193 15.5794 16.5619 15.1967 17.0142 14.7194C17.4664 14.242 17.8192 13.6796 18.0521 13.0646C18.285 12.4497 18.3933 11.7947 18.3708 11.1375C18.4018 10.4901 18.3017 9.84314 18.0764 9.23543C17.8511 8.62771 17.5053 8.0718 17.0598 7.60107C16.6143 7.13033 16.0782 6.75449 15.4838 6.49612C14.8894 6.23774 14.2489 6.10216 13.6008 6.09751ZM13.6008 14.9175C12.6238 14.8887 11.6976 14.4755 11.0235 13.7677C10.3495 13.06 9.98192 12.1147 10.0008 11.1375C9.98192 10.1603 10.3495 9.21507 11.0235 8.50728C11.6976 7.79949 12.6238 7.38631 13.6008 7.35751C14.5778 7.38631 15.504 7.79949 16.178 8.50728C16.8521 9.21507 17.2197 10.1603 17.2008 11.1375C17.2177 11.6234 17.1375 12.1077 16.9649 12.5622C16.7922 13.0167 16.5306 13.4321 16.1953 13.7842C15.86 14.1362 15.4578 14.4178 15.0123 14.6124C14.5668 14.807 14.0869 14.9108 13.6008 14.9175Z"
        fill="#007CBE"
      />
    </SvgIcon>
  );
}

export default CcfAttachmentPreviewIcon;
